import styled from '@emotion/styled';
import {css} from '@emotion/react';

const hoverImageCss = css`
  cursor: pointer;
  font-style: normal;
  position: relative;
  display: inline-block;
  --underlineline-height: 0.1ch;
  --underlineline-color: currentColor;

  .split-child {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: calc(100% - var(--underlineline-height));
      width: 100%;
      height: var(--underlineline-height);
      background: var(--underlineline-color);
    }
  }

  @media (hover: hover) {
    &:hover {
      color: #fff;
    }
  }
`;

export const Wrapper = styled.div<{hasHoverImages: boolean}>`
  display: block;
  position: relative;
  margin: 0;
  --color-text: #000;
  color: var(--color-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .image-preload {
    opacity: 0;
    left: -999rem;
    position: fixed;
    pointer-events: none;
  }

  .main-content {
    font-size: 2rem;
    line-height: 120%;
    font-weight: normal;
    opacity: 0;

    strong {
      font-weight: 800;
    }

    /* Only text with <em> tags will be underlined and have hover image reveals */
    em {
      font-style: italic;
      ${({hasHoverImages}) => hasHoverImages && hoverImageCss}
    }

    .split-parent {
      overflow: hidden;
    }

    .split-child {
      transform: translateY(100%);
      will-change: transform;
    }
  }

  .loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    transition: all 0.3s ease;
  }

  .imagesLoaded {
    .loader {
      opacity: 0;
      pointer-events: none;
    }
  }

  .hoverImage {
    width: 0;
    opacity: 0;
  }

  .hover-reveal {
    position: absolute;
    z-index: -1;
    max-width: 420px;
    top: 0;
    left: 0;
    pointer-events: none;
    opacity: 0;
    will-change: transform, filter;
    touch-action: none;

    // Styles for tablet screen size and below
    @media (max-width: 768px) {
      position: fixed;
      top: 50%;
      left: 50%;
    }
  }

  .hover-reveal__inner {
    overflow: hidden;
    height: 0;
  }

  .hover-reveal__inner,
  .hover-reveal__img {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .hover-reveal__img {
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
